<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Alertas"
      :backroute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="col-2">
      <span>Selecione o Usuario</span>
      <q-select
        v-model="selected"
        option-label="name"
        option-value="id"
        :options="rows"
        dense
        class="input-new-design col-2 q-mt-md"
        style="max-width: 20%"
        outlined
        map-options
        emit-value
        :rules="[(val) => !!val || 'Este campo é obrigatório']"
        @filter="filterFn"
        use-input
      >
      </q-select>
    </div>

    <div class="q-pt-md">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        title="Todos os alertas do sistema"
        :rows="rows2"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns2"
        :loading="disable"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template #body-cell-notification_display="props">
          <q-td>
            {{ props.row.notification_id }} -
            {{ props.row.notification_display }}
          </q-td>
        </template>
        <template #body-cell-description="props">
          <q-td>
            <q-toggle
              v-model="value"
              :val="props.row.notification_id"
              color="primary"
              @click="ativar(props.row.notification_id, $event)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

const columns2 = [
  {
    name: "notification_display",
    label: "Alerta",
    field: "notification_display",
    align: "left",
  },
  {
    name: "description",
    label: "Ativar/Desativar",
    field: "description",
    align: "left",
  },
];

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { PageHeader },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const rows2 = ref([]);
    const disable = ref(true);
    const selected = ref(null);
    const value = ref([]);
    const $q = useQuasar();
    const time = ref();
    const filter = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 15,
    });

    const getUsers = async (page = 0, rowsPerPage = 8, val = "") => {
      const response = await store.dispatch("adminMultpex/getUsers", {
        page,
        per_page: rowsPerPage,
        search: val,
      });

      rows.value = response.data.results.data;
      disable.value = false;
    };

    onMounted(getUsers);

    const getAlertas = async (id) => {
      disable.value = true;
      value.value = [];
      rows2.value = [];

      const response = await store.dispatch("adminMultpex/getAlertas", {
        userId: id,
      });

      rows2.value = response.data.results;

      response.data.results.forEach((e) => {
        if (e.optin == true) {
          value.value.push(e.notification_id);
        }
      });

      disable.value = false;
    };

    const handleRequest = async () => {
      getUsers(pagination.value.page, pagination.value.rowsPerPage);
    };

    const ativar = async (id, event) => {
      try {
        if (event.currentTarget.ariaChecked == "false") {
          await store.dispatch("adminMultpex/ativarAlerta", {
            optin: false,
            action: "optin",
            notification_id: id,
            user_id: selected.value,
          });
          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } else if (event.currentTarget.ariaChecked == "true") {
          await store.dispatch("adminMultpex/desativarAlerta", {
            optin: true,
            action: "optout",
            notification_id: id,
            user_id: selected.value,
          });

          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        getUsers();
      } catch (error) {
        $q.notify({
          message: "Erro a o configurar permissao",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => selected.value,
      () => {
        if (selected.value == null) {
          rows2.value = [];
          return;
        }
        getAlertas(selected.value);
      }
    );

    function filterFn(val, update) {
      clearTimeout(time.value);

      time.value = setTimeout(() => {
        getUsers(pagination.value.page, pagination.value.rowsPerPage, val);
      }, 1000);

      setTimeout(() => {
        update();
      }, 1500);
    }

    return {
      filterFn,
      pagination,
      rows,
      rows2,
      disable,
      columns,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      getAlertas,
      columns2,
      ativar,
      value,
      handleRequest,
      filter,
    };
  },
};
</script>
